export default __webpack_public_path__ + "static/media/blog_1.4c726d07.jpg";